// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"43":"dae10df6","98":"823779b8","194":"6ace7604","242":"6475e8b9","353":"26265843","459":"de8d93d5","783":"bd36cb47","788":"9fe59e6d","849":"3dd47e86","874":"87dcf62b","935":"08e620a7","979":"70dd4cee"}[chunkId] + ".chunk.js";
};